import React from 'react';

function IconChevronRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="evenodd"
        d="M2.47 10.955a.75.75 0 010-1.061l4.136-4.136L2.47 1.62A.75.75 0 013.53.561l5.197 5.197-5.197 5.197a.75.75 0 01-1.06 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconChevronRight;
